import ApiConfig from '../../config/api'

import BaseListModel from './BaseListModel'

export default class UserModel extends BaseListModel {
  apiUrl = ApiConfig.api.user.user_list
}

export const userStore = new UserModel()
